module.exports = __webpack_public_path__ + "static/media/logo-sso-microsoft.319d9b9a.svg";